/**
 * @param {String|Object} msg
 * @param {Object} [options]
 * @param {Boolean} [options.parent] - message the parent window if one exists
 * @param {DOMNode} [options.iframe] - iframe element to send the message to
 */
function publish(msg, options = {}) {
  if (options.iframe && options.iframe.contentWindow) {
    options.iframe.contentWindow.postMessage(msg, '*')
  } else if (options.parent && window.parent) {
    window.parent.postMessage(msg, '*')
  } else {
    window.postMessage(msg, '*')
  }
}

function subscribe(event, handler) {
  window.addEventListener(event, handler)
}

function unsubscribe(event, handler) {
  window.removeEventListener(event, handler)
}

function inIframe() {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

var documentReferrer = document.referrer

function topLevelUrl() {
  if (inIframe() !== true) {
    return window.location.href
  }
  if (window.location.ancestorOrigins && window.location.ancestorOrigins.length) {
    return window.location.ancestorOrigins[0]
  }
  return documentReferrer || window.location.href
}

export default {
  publish,
  subscribe,
  unsubscribe,
  inIframe,
  documentReferrer,
  topLevelUrl,
}



// WEBPACK FOOTER //
// ./src/lib/iframe.js